export default __webpack_public_path__ + "static/media/mallory_compact_ultra.42db7598.ttf";